"use client";
import React from "react";
import styles from "./LayOut.module.scss";
import { useAppSelector } from "../../../app/GlobalRedux/store";
import MoreLikeThisModal from "@/components/MoreLikeThisModal/MoreLikeThisModal";

interface LayOutProps {
  children: React.ReactNode;
}

const LayOut = ({ children }: LayOutProps) => {
  const modalInfo = useAppSelector((state) => state.moreLikeThis);

  return (
    <div className={styles.wrapper}>
      {children}

      {modalInfo.isOpen && (
        <MoreLikeThisModal
          image_url={modalInfo.image_url}
          caption={modalInfo.caption || "no caption found"}
        />
      )}
    </div>
  );
};

export default LayOut;
